import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';

import moment from 'moment';
import type { IResourceModel } from '@/shared/model/briefing-widget.model';
import ResourceFooterComponent from '@/shared/cards/briefing/resource/components/resource-footer/resource-footer.vue';
import { formatDateAgo } from '../../../../../util/date-util';
import GoCardFooterVer2 from '@/shared/cards/footer/go-card-footer-v2.vue';

@Component({
  methods: { formatDateAgo },
  components: {
    'resource-footer': ResourceFooterComponent,
    'go-card-footer-v2': GoCardFooterVer2,
  },
  computed: {
    moment() {
      return moment;
    },
    isContentNew() {
      return this.formModel && this.formModel.isNew;
    },
  },
})
export default class TopicWidget extends Vue {
  @Prop(Object) readonly formModel: IResourceModel;
  @Prop(Boolean) readonly isHideOptions: boolean;
  @Prop(Boolean) readonly isHideHidden: boolean;
  @Prop(Boolean) readonly isHideGoover: boolean;
  @Prop(Boolean) readonly isHideShared: boolean;
  @Prop(Boolean) readonly isHideAddReference: boolean | false;

  private imagePath = '@/../content/images/';
  private topicFailedImg = this.imagePath + 'images_v3/common/go-empty-thumb-sz176.png';
  isShowImage = true;
  currentProgress = 1;
  totalDuration = 5 * 60 * 1000;
  updateDuration = 2 * 60 * 1000;
  updateInterval = 1000;
  maxProgress = 100;
  intervalLoadingTopicCard;
  timerStopLoadingTopicCard;
  resetProgress = false;
  isShowReloading = false;

  @Emit('share') share() {}

  @Emit('hide') hide() {}

  @Emit('select-user-social') selectUserSocial() {}

  @Emit('view-detail') viewDetail() {}

  @Emit('toggle-resource') toggleResource() {}

  @Emit('add-to-reference') addToReference() {}

  @Emit('goover') goover() {}

  mounted() {
    this.clearLoadingTopic();
    this.handleClearTimeOutStopTopicCard();
    // if (this.formModel && this.formModel.requestIdReportNoBriefing !== undefined) {
    //   this.startProgress();
    // }
    this.checkImage(this.formModel.thumbnail);
  }

  beforeDestroy() {
    this.clearLoadingTopic();
    this.handleClearTimeOutStopTopicCard();
  }

  @Watch('formModel')
  onFormModelChange() {
    // if (this.formModel && this.formModel.requestIdReportNoBriefing !== undefined) {
    //   this.clearLoadingTopic();
    //   this.handleClearTimeOutStopTopicCard();
    //   this.startProgress();
    // }
  }

  clearLoadingTopic() {
    this.currentProgress = 1;
    this.resetProgress = true;
    this.isShowReloading = false;

    if (this.intervalLoadingTopicCard) {
      clearInterval(this.intervalLoadingTopicCard);
    }
  }

  get source() {
    console.log('get source ', this.formModel);
    return this.formModel.userProfile?.userKey === this.$store.getters?.userIdentity?.id ? 'me' : 'others';
  }

  onImageError() {
    // Vue.set(this.formModel, 'thumbnail', undefined);
    Vue.set(this.formModel, 'thumbnail', this.topicFailedImg);
  }

  startProgress() {
    this.intervalLoadingTopicCard = setInterval(() => {
      if (this.resetProgress) {
        this.currentProgress = 1;
        this.resetProgress = false;
      } else {
        this.currentProgress += this.maxProgress / (this.updateDuration / this.updateInterval);
      }

      if (this.currentProgress >= this.maxProgress) {
        this.resetProgress = true;
        this.currentProgress = this.maxProgress;
      }
    }, this.updateInterval);

    this.timerStopLoadingTopicCard = setTimeout(() => {
      clearInterval(this.intervalLoadingTopicCard);
      this.isShowReloading = true;
    }, this.totalDuration);
  }

  handleReloadingReportCard() {
    this.handleClearTimeOutStopTopicCard();
    this.clearLoadingTopic();

    this.$nextTick(() => {
      setTimeout(() => {
        this.startProgress();
      }, 100);
    });
  }

  handleClearTimeOutStopTopicCard() {
    if (this.timerStopLoadingTopicCard) {
      clearTimeout(this.timerStopLoadingTopicCard);
      this.timerStopLoadingTopicCard = null;
    }
  }

  checkImage(url) {
    const img = new Image();
    img.src = url;

    // Xử lý khi ảnh tải thành công
    img.onload = () => {
      this.isShowImage = true;
    };

    // Xử lý khi ảnh lỗi
    img.onerror = () => {
      this.isShowImage = false;
    };
  }
}
